import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SavingsListFacade } from "./savings-list.facade";
import { FiatPrecisionSymbolPipe } from "@modules/core/pipes";
import { SavingsPlan } from "@models/savings_plan";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SavingsListViewModel } from "@modules/shared/domain/entities/savings-list-view.model";
import { Fiat } from "@models";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";

@Component({
	selector: "savings-list",
	templateUrl: "./savings-list.component.html",
	styleUrls: ["./savings-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SavingsListComponent {
	public isHideValueActive$: Observable<boolean> = this.portfolioFacade.isPortfolioDataHidden$;

	public savingsListView$: Observable<SavingsListViewModel[]> = this.route.params.pipe(
		switchMap((params: Params) => this.savingsListFacade.getSavingsListView$(params["assetId"] || ""))
	);

	constructor(
		private savingsListFacade: SavingsListFacade,
		private precisionSymbolPipe: FiatPrecisionSymbolPipe,
		private router: Router,
		private route: ActivatedRoute,
		private readonly portfolioFacade: PortfolioFacade
	) {}

	public onPlanClick(plan: SavingsPlan): void {
		this.savingsListFacade.getFullPlanDetails(plan);
		this.router.navigateByUrl(`/my-account/savings/(modal:receive-param/${plan.getId()}`, {
			skipLocationChange: true
		});
	}

	public getFiat(plan: SavingsPlan): Fiat {
		return this.savingsListFacade.getFiat(this.savingsListFacade.getFiatId(plan));
	}
}
